import React, { useEffect, useRef } from 'react';

function RawInput(props, ref) {
    const {
        type,
        value,
        debounce,
        onChange,
    } = props;

    const [timeout, updateTimeout] = React.useState(null);
    const [valueState, setValueState] = React.useState(value);

    // update the value state when the value prop changes.
    const prevInput = useRef();
    useEffect(() => {
        if (prevInput.current !== value) {
            setValueState(value);
        }

        prevInput.current = value;
    }, [value]);

    // handles value update, will debounce if debounce is set.
    const handleChange = (e) => {
        const valueState = type === 'file' ? e.target.files : e.target.value;
        setValueState(valueState);

        const time = parseInt(debounce);

        if ((!debounce || isNaN(time)) && onChange) {
            return onChange(valueState);
        }

        clearTimeout(timeout);
        updateTimeout(setTimeout(() => {
            if (onChange) {
                onChange(valueState);
            }
        }, time));
    };

    return (
        <input
            {...props}
            ref={ref}
            value={valueState ?? value ?? ''}
            onChange={handleChange}
        />
    );
}

export default React.forwardRef(RawInput);
